import PropertyValue from '@/components/Typography/PropertyValue';
import SentimentBadge from '@/features/Feedback/field/Sentiment/SentimentBadge';
import SentimentSelectModal from '@/features/Feedback/field/Sentiment/SentimentDropdown/SentimentSelectModal';
import { useElementRef } from '@/hooks/pure/useElementRef';
import useFeedbackListStore from '@/stores/Feedback/FeedbackListStore';
import useDropdownStore from '@/stores/pure/DropdownStore';
import { FeedbackSentiment } from '@/types/feedbackConst';

import { useFeedbackDetailContext } from '../../context/FeedbackDetailContext';
import { PropertyRowWrapper } from './PropertyRowWrapper';
import type { CommonFieldProps } from './types';

export const EndSentimentField = (
  props: CommonFieldProps & {
    feedback_alias: string;
    key_sentiment?: FeedbackSentiment;
    end_sentiment?: FeedbackSentiment;
    sentiment_detail?: FeedbackSentiment[];
  },
) => {
  const setCurrDropdown = useDropdownStore((state) => state.setCurrDropdown);
  const { elementRef: endSentimentElement, setElementRef } =
    useElementRef<HTMLDivElement>();

  const { updateDetail } = useFeedbackDetailContext();

  const changeEndingSentiment = useFeedbackListStore(
    (state) => state.changeEndingSentiment,
  );

  if (!props.showFull && !props.end_sentiment) return null;

  return (
    <PropertyRowWrapper {...props} expandable>
      <div className="flex flex-wrap gap-0.5">
        <PropertyValue
          ref={setElementRef}
          onClick={() => setCurrDropdown('end_sentiment')}
          value={
            <div className="flex gap-1.5">
              <SentimentBadge
                type={props.end_sentiment || FeedbackSentiment.NEUTRAL}
              />
            </div>
          }
        />
      </div>
      <SentimentSelectModal
        selected={props.end_sentiment}
        feedbackKey={props.feedback_alias}
        name="end_sentiment"
        triggerEl={endSentimentElement}
        onSelect={(key) => {
          changeEndingSentiment(props.feedback_alias, key as FeedbackSentiment);
          updateDetail({
            ending_sentiment: key as FeedbackSentiment,
          });
        }}
      />
    </PropertyRowWrapper>
  );
};
